import { RootState } from "@src/reducers/store";
import React from "react";
import { useSelector } from "react-redux";
import { FindAutoMatchBlueprintModalContent } from "./find-auto-match-blueprint-modal-content/find-auto-match-blueprint-modal-content";
import { ApplyAutoMatchBlueprintContent } from "./apply-selected-blueprint-content/apply-auto-match-blueprint-content";

import styles from "./auto-match-blueprint-modal.module.scss";
import { GlassyModal } from "../../glassy-modal/glassy-modal";

const cssClassName = "auto-match-blueprint-modal";

export const AutoMatchBlueprintModal = () => {
  const autoMatchBlueprintModalContentShown = useSelector(
    (state: RootState) =>
      state.yourSlice.autoMatchBlueprintModal
        .autoMatchBlueprintModalContentShown,
  );

  const renderFindOrReplaceBlueprintModalContent = (value) => {
    switch (value) {
      case "find":
        return <FindAutoMatchBlueprintModalContent />;
      case "apply":
        return <ApplyAutoMatchBlueprintContent />;
      default:
        return <FindAutoMatchBlueprintModalContent />;
    }
  };

  return (
    <GlassyModal>
      <div className={styles[cssClassName]}>
        {renderFindOrReplaceBlueprintModalContent(
          autoMatchBlueprintModalContentShown,
        )}
      </div>
    </GlassyModal>
  );
};
